import React, {useContext} from 'react';
import { useQueryClient } from 'react-query';
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import _ from "underscore";

import {useAddPerson, usePersons} from "../../../services/persons";
import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import editPersonDialog from "./EditPersonDialog";
import SystemContext from "../../../SystemContext";

const apiSitePrefix = getApiSitePrefix();
const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const PersonDialogs = (SystemData, apiSitePrefix, extraKeys, handleAdd, handleUpdate, formatChars, classes, updateParent) => {
  const {Dialog: EditPersonDialog, open: openEditPerson, close: closeEditPerson} = editPersonDialog(SystemData, apiSitePrefix, extraKeys, handleAdd, handleUpdate, formatChars, classes, updateParent);

  return {
    EditPersonDialog, openEditPerson, closeEditPerson,
  }
}

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
});

const PersonLookup = props => {

  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    },
    PassportEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
  }))(theme);

  const handleAddPerson = useAddPerson();

  const queryClient = useQueryClient();
  const extraKeys = [];
  const allRecords = usePersons({queryClient, useCache: false, extraKeys});

  const records = allRecords?{...allRecords}:allRecords;
  if (!props.includeNew && records.data && Array.isArray(records.data)){
    records['data'] = _.filter(records.data, (person) => {return person.isNew});
  }

  const handleChange = (event, record) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = { value: record.personUuid, found: false, data: {}}
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      if (record && record.isNew) {
        openEditPerson({}, null, true, null);
        return;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.personUuid);
      }
    }
  }
  const handleInputChange = (event, value) => {
    if (!event || (event.type !== 'change' && !(event.type === 'blur' && value))) return;
    if (props.returnType === "object") {
      const returnObject = { value, found: false, data: {} }
      const record = _.findWhere(records.data, { personUuid: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      if (record && record.isNew)
        return;
      props.onChange(returnObject);
    } else {
      props.onChange(value);
    }
  }

  const getNewPerson = (personRecord) => {
    const returnObject = { value: "", found: false, data: {} }
    if (personRecord) {
      returnObject.found = true;
      returnObject.data = personRecord;
    }
    props.onChange(returnObject);
  }

  const {
    EditPersonDialog, openEditPerson
  } = PersonDialogs(SystemData, apiSitePrefix, [], handleAddPerson, null, formatChars, classes, getNewPerson);

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  const defaultFilterOptions = (options, state) => {
    if (state.inputValue) {
      const searchCode = state.inputValue.toUpperCase();
      return _.filter(options, (person) => {
        const forename = person.forename||"";
        const surname = person.surname||"";
        return (forename.toUpperCase().startsWith(searchCode) || surname.toUpperCase().indexOf(searchCode) >= 0)
      });
    } else return options.slice(0, 300);
}
  const filterOptions = props.filterOptions || defaultFilterOptions;

  if (props.type === "render") {
    return <div>{records.data && _.find(records.data, {personUuid: props.value})?`${_.find(records.data, {personUuid: props.value}).forename} - ${_.find(records.data, {personUuid: props.value}).surname}`:''}</div>
  } else {
    return (
      <div>
        <Autocomplete
          id={props.id}
          disableClearable={true}
          autoSelect={(records && records.data)?true:false}
          autoHighlight={true}
          inputValue={props.value}  //{records.data && _.find(records.data, {personUuid: props.value})?!props.alwaysShowKnownAs?_.find(records.data, {personUuid: props.value}).forename + " " + _.find(records.data, {personUuid: props.value}).surname:_.find(records.data, {personUuid: props.value}).knownAs:props.value||""}
          options={records.data||[]}
          filterOptions={filterOptions}
          PopperComponent={DropdownList}
          getOptionSelected={(option, value) => option.personUuid === value.personUuid}
          getOptionLabel={(option) => option.personUuid}
          onChange={handleChange}
          onInputChange={handleInputChange}
          disabled={props.disabled||props.readOnly}
          renderOption={(option) => (
            <React.Fragment key={`person-lookup-${option.personUuid}`}>
              {option.forename} {option.surname}
            </React.Fragment>
          )}
          style={{
            width: (props.width||"100%"),
          }}
          renderInput={(params) => {
            let value = params.inputProps.value||"";
            const record = _.find(records.data, {personUuid: value});
            if (record) {
              value = record.knownAs||"";
            }
            const extraProps = {};
            if (props.readOnly) {
              extraProps.className = classes.readOnly;
            }
            const inputProps = {
              ...props.inputProps,
              ...params.inputProps,
              ...extraProps,
              value
            }
            return (<TextField
              {...params}
              label={props.label}
              placeholder={props.placeHolder}
              inputProps={{...inputProps}}
              InputLabelProps={{shrink: props.shrink}}
            />)
          }}
        />

        <EditPersonDialog classes={classes}/>
      </div>
    )
  }
}

export default withStyles(styles) (PersonLookup);
